// Generally detects if a device is iOS or not. Note: this is inherently imprecise and depending on _why_ you need to know whether a device is iOS or not, this may or may not be the best approach.
// src: https://stackoverflow.com/a/9039885
export const isiOS = () =>
  ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
    navigator.platform,
  ) ||
  // iPad on iOS 13 detection
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
